import { GET_JEWELLERY_TYPES_LOADING, GET_JEWELLERY_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getJewelleryTypesSuccess = payload => {
    return ({
        type: GET_JEWELLERY_TYPES_SUCCESS,
        payload
    })
}

export const getJewelleryTypesAsync = payload => dispatch => {
    return client.service('jewellery-types').find()
		.then((response) => {
            dispatch(getJewelleryTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}